// Le promesse operative dell'Osservatorio, in un posto solo.
//
// Fino al 30/09/2026 i tempi di risposta erano scritti a mano in una
// ventina di punti e dicevano due cose diverse: «entro 48 ore» su
// /contatti, /accoglienza, nel piede e nei due moduli (compresa la frase
// con cui il modulo ringrazia), «entro 48–72 ore» su /chi-siamo, nel
// banner «Parliamone» (`ContactBanner`) e nel riquadro finale di ogni
// pagina servizio, /servizi/monitoraggio compresa. Chi leggeva le due
// pagine di fila riceveva due impegni, e il modulo confermava il più
// stretto: il lettore lo prende per un errore, e ha ragione.
//
// Vale **48 ore**: è quello che promette il modulo nel momento in cui
// uno scrive, e quello che il route handler ripete quando il canale è
// giù. Cambiarlo qui lo cambia dappertutto.
//
// Da non confondere con il «48–72h» di `lib/servicePhases.ts`: quello è
// il tempo medio di consegna di un servizio, non la prima risposta.
//
// Il file non importa niente di server-only ed è letto anche da
// componenti client (i due moduli, il diagramma di /accoglienza).

/** Ore entro cui arriva la prima risposta a chi scrive. */
export const ORE_RISPOSTA = 48;

/** Le forme in cui la promessa compare nel testo. */
export const RISPOSTA = {
  /** «48h», per targhe, occhielli e cifre grandi. */
  breve: `${ORE_RISPOSTA}h`,
  /** «48 ore», per la prosa: «ti richiamiamo entro 48 ore». */
  ore: `${ORE_RISPOSTA} ore`,
} as const;

/** La modalità, nelle due parole con cui la dicono occhielli e targhe. */
export const SOTTO_NDA = "sotto NDA";

/** Occhiello delle aperture di /contatti e /accoglienza: «48h · sotto NDA». */
export const OCCHIELLO_RISPOSTA = `${RISPOSTA.breve} · ${SOTTO_NDA}`;

/**
 * Le quattro condizioni di lavoro, nella forma a cifra grande più
 * didascalia che usano il banner «Parliamone», la striscia finale di
 * /chi-siamo e il riquadro finale delle pagine servizio. Erano tre copie
 * dello stesso array, scritte a mano.
 */
export const CONDIZIONI: ReadonlyArray<{ v: string; k: string }> = [
  { v: "7 / 7", k: "Sempre raggiungibili" },
  { v: RISPOSTA.breve, k: "Prima risposta" },
  { v: "NDA", k: "Sotto accordo" },
  { v: "Riservato", k: "Numero limitato di clienti" },
];
